import React from 'react';

import { Button, ButtonVariant } from 'lib/ui';

const ButtonSubmit = ({ ...props }) => (
  <Button variant={ButtonVariant.Primary} iconName="save" {...props} />
);

export { ButtonSubmit };
